import { render, staticRenderFns } from "./AccountStatisticSystem.vue?vue&type=template&id=1ab0dde2"
import script from "./AccountStatisticSystem.vue?vue&type=script&lang=js"
export * from "./AccountStatisticSystem.vue?vue&type=script&lang=js"
import style0 from "./AccountStatisticSystem.vue?vue&type=style&index=0&id=1ab0dde2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports